import { HttpStatusCode } from "./http-status-codes";

export enum ApiErrorCode {
  ExpiredOrInvalidToken = "6401",
}

type ApiFetchErrorResponse = {
  error: {
    message: string;
    code?: string;
    innerError?: unknown;
  };
};

type ApiMutationErrorResponse = {
  Error: {
    ErrorCode?: string;
    ErrorMessage: string;
  };
};

export class ResponseError extends Error {
  public readonly status: number;
  public readonly code?: ApiErrorCode | string | number;

  constructor(message: string, status: number, code?: string) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

export function isUnauthorized(error: Error): error is ResponseError {
  return (
    error instanceof ResponseError &&
    error.status === HttpStatusCode.Unauthorized
  );
}

export function getFetchErrorType(error: unknown): "api" | "network" {
  return error instanceof ResponseError ? "api" : "network";
}

export function isApiFetchErrorResponse(
  error: unknown
): error is ApiFetchErrorResponse {
  return (error as ApiFetchErrorResponse)?.error?.message !== undefined;
}

export function isApiMutationErrorResponse(
  error: unknown
): error is ApiMutationErrorResponse {
  return (error as ApiMutationErrorResponse)?.Error?.ErrorMessage !== undefined;
}
